export * from './angularx-qrcode';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularx-qrcode/dist/components/index.js
// module id = 146
// module chunks = 0